<template>
    <div :key="componentKey">
        <el-upload 
            class="position-relative" 
            action=""
            :on-preview="handlePreview" 
            :file-list="anexosfiltrados" 
            :limit="2"
            :before-remove="handleRemove" 
            list-type="picture" 
            accept="image/jpeg,image/png,application/pdf"
            :before-upload="beforeUpload"
        >
            <div class="header-file-attachment">
                {{ tipoAnexo.descricao }}
            </div>

            <button class="card-file-attachment">
                <el-badge is-dot class="item card-file-attachment--dot" :type="tipoAnexo.obrigatorio ? 'danger' :'primary' "></el-badge>

                <i class="el-icon-upload card-file-attachment-icon"></i>
                Adicionar arquivo
            </button>

            <div slot="tip" class="el-upload__tip mt-2">
                    <i class="el-icon-warning-outline"></i> 
                JPG/PNG/PDF com tamanho máximo de 5Mb
            </div>
        </el-upload>

        <el-drawer direction="ltr" :visible.sync="drawer" size="80%">
            <el-row type="flex" justify="center" align="center">
                <img v-if="filePreview" :src="filePreview" alt="Imagem Carregada" />
            </el-row>
        </el-drawer>
        <div class="card-file-attachment-subtitles">
            <h6>Legenda:</h6>
            <div class="card-file-attachment-subtitles-content">
                <el-badge is-dot class="item">
                    <div class="rounded border px-2 py-1">
                        <small>Anexo Obrigatório</small>
                    </div>
                </el-badge>

                <el-badge is-dot class="item" type="primary">
                    <div class="rounded border px-2 py-1">
                        <small>Anexo Opcional</small>
                    </div>
                </el-badge>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        Upload,
        Col,
        Row,
        Drawer,
        Message,
        Button,
        Badge,
    } from "element-ui";

    export default {
        name: "anexo",
        props: {
            tipoAnexo: {
                type: Object,
                defatul: {}
            },
            anexos: {
                type: Array,
                default: []
            }
        },
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Upload.name]: Upload,
            [Drawer.name]: Drawer,
            [Message.name]: Message,
            [Button.name]: Button,
            [Badge.name]: Badge
        },
        data() {
            return {
                componentKey: 0,
                list: [],
                drawer: false,
                innerDrawer: false,
                filePreview: {},
                anexosComponente: this.anexos,
            }
        },
        mounted() {
        },
        computed: {
            anexosfiltrados() {
                const vm = this;
                const anexos = vm.anexosComponente.filter((el) => {
                    if (el.idTipoAnexo == vm.tipoAnexo.id) {
                        if (el.id && el.url_arquivo) {
                            el.name = el.descricao
                            el.url = (process.env.apiUrl + el.url_arquivo).replace('/api', '')
                        }
                        return el
                    }
                });
                return anexos
            }
        },

        methods: {
            beforeUpload(file) {
                if (file != undefined) {
                    const maxSize = 5 * 1024 * 1024;
                    const isIMGorPDF = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
                    if (file.size > maxSize) {
                        Message.error('O arquivo é muito grande. O tamanho máximo é 5MB.');
                        return false;
                    } else if (!isIMGorPDF) {
                        Message.error('Apenas arquivos JPEG, PNG e PDF são permitidos.');
                        return false;
                    }
                    file.idTipoAnexo = this.tipoAnexo.id
                    file.url = URL.createObjectURL(file)
                    this.anexosComponente.push(file)
                    this.$emit("anexos", this.anexosComponente);
                    return true;
                }
            },

            handleRemove(file, fileList) {
                this.anexosComponente = this.anexosComponente.filter(el => el.url !== file.url);
                const id = file?.id ? file.id : ""
                if(id) {
                    this.$emit("removeAnexo", id);
                }
                this.$emit("anexos", this.anexosComponente);
            },
            handlePreview(file) {
                let type_url = ''
                if (file.id && file.url_arquivo) {
                    type_url = this.verificarTipoDeArquivo(file.url)
                }
                if (file.type === 'image/jpeg' || file.type === 'image/png' || type_url == 'jpg' || type_url == 'jpeg' || type_url == 'png') {
                    this.filePreview = file.url;
                    this.drawer = true;
                } else if (file.type === 'application/pdf' || type_url == 'pdf') {
                    window.open(file.url, '_blank');
                }
            },

            verificarTipoDeArquivo(url) {
                // verificando a extensão do arquivo da URL
                const extensao = url.split('.').pop().toLowerCase();
                const tiposSuportados = ['jpg', 'jpeg', 'png', 'pdf'];
                if (tiposSuportados.includes(extensao)) {
                    return extensao
                } else {
                    return false
                }
            }
        }
    }
</script>
<style>
    .item {
        >.is-dot {
            width: 12px;
            height: 12px;
        }
    }

    .el-upload {
        display: block;
        max-width: fit-content;
    }

    .el-upload-list__item-thumbnail {
        border-radius: 10px;
        border: 1px solid #dedede;
    }

    .el-upload-list__item {
        min-width: 236px;
        max-width: 400px;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .header-file-attachment {
        position: absolute;
        left: 12px;
        top: 12px;

        font-size: 12px;
    }

    .card-file-attachment {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        
        border-radius: 5px;
        background: none;
        color: #565656;
        border: 1px dashed #565656;
        height: 156px;
        padding: 40px;
        font-weight: 600;
        position: relative;
        text-transform: none;
        transition: all 200ms ease;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);

        >.card-file-attachment--dot {
            position: absolute;
            right: 8px;
            top: 8px;
        }
    }

    .card-file-attachment:hover {
        border-color: #2b7fff;
        color: #2b7fff;

        > .card-file-attachment-icon {
            color: #2b7fff;
        }
    }

    .card-file-attachment-subtitles {
        padding-block: 12px;

        >.card-file-attachment-subtitles-content {
            display: flex;
            align-items: center;
            gap: 12px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/util/anexo.vue